define('helperEntity-isQuizTaskPage',['helperContent-getEntity', 'helperEntity-isParentQuizTaskPage'], function(getEntity, isParentQuizTaskPage) {
    'use strict';

    var isQuizTaskPage = function(ID, contentEntities) {
        var entity;

        ID = ID || null;

        if (!ID) {
            return false;
        }

        entity = getEntity(ID, contentEntities);

        if (!entity) {
            return false;
        }

        return isParentQuizTaskPage(entity.contentEntity.parentId, contentEntities);
    };

    return isQuizTaskPage;
});

